import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = {
  login: `/accessToken`,
  logout: '/logout',
  userEdit: '/users',
};

function api() {
  return {
    login: (data) => {
      return HttpRequest.post(getUrl.login, data.payload);
    },
    
    update: (data: RequestData) => {
      const url = `${getUrl.userEdit}/${getPropByString(data, "params.id")}`;
      return HttpRequest.put(url, data.payload, {});
    },
    
    changePassword: (data: RequestData) => {
      const url = `${getUrl.userEdit}/${getPropByString(data, "params.id")}/changePassword`;
      return HttpRequest.put(url, data.payload, {});
    },
    
    resetPassword: (data: RequestData) => {
      const url = `${getUrl.userEdit}/${getPropByString(data, "params.id")}/resetPassword`;
      return HttpRequest.post(url, data.payload, {});
    },
    
    logout: (data) => {
      return HttpRequest.post(getUrl.logout);
    }
   
  };
}

export default api();
